var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAllDrinks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 60,
    viewBox: "0 0 46 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.905605,
    y: 0.905605,
    width: 43.469,
    height: 43.469,
    rx: 21.7345,
    stroke: "#FCC436",
    strokeWidth: 1.81121
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.182 57.7139L20.0675 51.0539H20.927L22.799 57.7139H22.2185L20.4905 51.4364H20.4995L18.7625 57.7139H18.182ZM19.046 55.8644V55.3739H21.9485V55.8644H19.046ZM24.5813 50.6804V57.7139H24.0323V50.6804H24.5813ZM26.7522 50.6804V57.7139H26.2032V50.6804H26.7522Z",
    fill: "#797D86"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1771 25.355V32.9695H17.6653H17.5627V33.072V35.1229V35.2254H17.6653H28.9449H29.0474V35.1229V33.072V32.9695H28.9449H24.433V25.355L35.6859 13.0304L35.7127 13.0011V12.9613V10V9.89746H35.6102H11H10.8975V10V12.9613V13.0011L10.9243 13.0304L22.1771 25.355ZM13.1783 12.1534H33.4318L30.3422 15.5373H16.268L13.1783 12.1534ZM18.3277 17.7932H28.2824L23.3202 23.228H23.2899L18.3277 17.7932Z",
    fill: "#FCC436",
    stroke: "#FCC436",
    strokeWidth: 0.205085
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3051 26.4067L16.2008 17.1779L30.4094 17.1779L23.3051 26.4067Z",
    fill: "#FCC436"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllDrinks);
export default __webpack_public_path__ + "static/media/AllDrinks.5dd7f83942f118ab7f9b44599bcc72cc.svg";
export { ForwardRef as ReactComponent };